import { PrintSetupSettings } from '@/pages/fulfillment/components/PrintSetupSettings';
import { useModalDialog } from '@/pages/fulfillment/components/useModalDialog';

export interface ScanDeskSettingsModalProps {
  autoPrintOnScan: boolean;
  onAutoPrintOnScanChange: (on: boolean) => void;
  onClose: () => void;
}

/** This workstation's own choices for the scan desk, kept in this browser [SSD-7415], and its label printer setup (SSD-7389). */
export function ScanDeskSettingsModal({
  autoPrintOnScan,
  onAutoPrintOnScanChange,
  onClose,
}: ScanDeskSettingsModalProps) {
  const dialogRef = useModalDialog(onClose);

  return (
    <dialog ref={dialogRef} className="vo-modal vo-settings" aria-label="View Orders settings">
      <header>
        Settings
        <button type="button" className="x" aria-label="Close" onClick={onClose}>
          ✕
        </button>
      </header>
      <div className="body">
        <label className="vo-setting">
          <input
            type="checkbox"
            role="switch"
            checked={autoPrintOnScan}
            onChange={(event) => onAutoPrintOnScanChange(event.target.checked)}
          />
          <span>
            <b>Auto-print label on scan</b>
            <span className="mut">
              The scan that opens an order prints its carrier label and PACKING, as Print does, when nothing bought for
              it has been received yet (warehouse stock does not count), or when the parcel scanned brings everything
              still waiting. Each order prints once on this PC. Off: a scan only opens the order. Saved on this PC.
            </span>
          </span>
        </label>
        <PrintSetupSettings />
      </div>
      <div className="foot">
        <button type="button" className="btn btn-line" onClick={onClose}>
          Done
        </button>
      </div>
    </dialog>
  );
}
